import type { KanbanLog } from './interfaces'

import { DateFormat } from '@brighterly/lib-core-types/date/enums'

import dayjs from 'dayjs'

import { KanbanLogAction, KanbanLogField } from './enums'

interface KanbanLogItemReturn {
  refDate: ComputedRef<string>
  refIsStatus: ComputedRef<boolean>
  refIsTaskType: ComputedRef<boolean>
  refIsExtraFields: ComputedRef<boolean>
  refIsAssignee: ComputedRef<boolean>
  refIsAgent: ComputedRef<boolean>
  refIsCreator: ComputedRef<boolean>
  refIsDeadline: ComputedRef<boolean>
  refIsComment: ComputedRef<boolean>
}

const COMMENT_ACTIONS = new Set<string>([
  KanbanLogAction.CommentAdded,
  KanbanLogAction.CommentEdited,
  KanbanLogAction.CommentDeleted,
])

const STATUS_FIELDS = new Set<string>([
  KanbanLogField.Status,
  KanbanLogField.Stage,
])

const DEADLINE_FIELDS = new Set<string>([
  KanbanLogField.Deadline,
  KanbanLogField.StageDeadline,
])

export const useKanbanLogItem = (refLog: ComputedRef<KanbanLog>): KanbanLogItemReturn => {
  const refDate = computed<string>(() => dayjs(refLog.value.created_at).format(DateFormat.KanbanDate))

  const refIsStatus = computed<boolean>(() => !!refLog.value.field && STATUS_FIELDS.has(refLog.value.field))
  const refIsTaskType = computed<boolean>(() => refLog.value.field === KanbanLogField.TaskType)
  const refIsExtraFields = computed<boolean>(() => refLog.value.field === KanbanLogField.ExtraFields)
  const refIsAssignee = computed<boolean>(() => refLog.value.field === KanbanLogField.Assignee)
  const refIsAgent = computed<boolean>(() => refLog.value.field === KanbanLogField.Agent)
  const refIsCreator = computed<boolean>(() => refLog.value.field === KanbanLogField.Creator)
  const refIsDeadline = computed<boolean>(() => !!refLog.value.field && DEADLINE_FIELDS.has(refLog.value.field))
  const refIsComment = computed<boolean>(() => COMMENT_ACTIONS.has(refLog.value.action))

  return {
    refDate,
    refIsStatus,
    refIsTaskType,
    refIsExtraFields,
    refIsAssignee,
    refIsAgent,
    refIsCreator,
    refIsDeadline,
    refIsComment,
  }
}
